import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var MicrosoftOfficeWordColorIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m5.322 16.797 7.2-9.02 8.228 5.864v6.012c0 1.018-.807 1.847-1.8 1.847H8.408c-1.702 0-3.086-1.42-3.086-3.167v-1.535Z",
        fill: "url(#paint0_radial_869_1253)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.322 10.438c0-1.314 1.034-2.375 2.314-2.375h10.486l2.628-1.34v6.597c0 1.018-.807 1.847-1.8 1.847H8.408c-1.702 0-3.086 1.42-3.086 3.166v-7.895Z",
        fill: "url(#paint1_linear_869_1253)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.322 10.438c0-1.314 1.034-2.375 2.314-2.375h10.486l2.628-1.34v6.597c0 1.018-.807 1.847-1.8 1.847H8.408c-1.702 0-3.086 1.42-3.086 3.166v-7.895Z",
        fill: "url(#paint2_radial_869_1253)",
        fillOpacity: 0.6
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.322 10.438c0-1.314 1.034-2.375 2.314-2.375h10.486l2.628-1.34v6.597c0 1.018-.807 1.847-1.8 1.847H8.408c-1.702 0-3.086 1.42-3.086 3.166v-7.895Z",
        fill: "url(#paint3_radial_869_1253)",
        fillOpacity: 0.1
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.322 5.667C5.322 3.92 6.706 2.5 8.408 2.5H18.95c.993 0 1.8.829 1.8 1.847v2.64c0 1.018-.807 1.846-1.8 1.846H8.408c-1.702 0-3.086 1.42-3.086 3.167V5.667Z",
        fill: "url(#paint4_linear_869_1253)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.322 5.667C5.322 3.92 6.706 2.5 8.408 2.5H18.95c.993 0 1.8.829 1.8 1.847v2.64c0 1.018-.807 1.846-1.8 1.846H8.408c-1.702 0-3.086 1.42-3.086 3.167V5.667Z",
        fill: "url(#paint5_radial_869_1253)",
        fillOpacity: 0.8
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.307 11.472H4.42c-.923 0-1.671.768-1.671 1.716V18.2c0 .948.748 1.716 1.671 1.716h4.886c.923 0 1.671-.768 1.671-1.716v-5.013c0-.948-.748-1.716-1.671-1.716Z",
        fill: "url(#paint6_radial_869_1253)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.307 11.472H4.42c-.923 0-1.671.768-1.671 1.716V18.2c0 .948.748 1.716 1.671 1.716h4.886c.923 0 1.671-.768 1.671-1.716v-5.013c0-.948-.748-1.716-1.671-1.716Z",
        fill: "url(#paint7_radial_869_1253)",
        fillOpacity: 0.65
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m9.686 13.283-1.013 4.824H7.465l-.597-2.893-.627 2.898H5.017l-.972-4.824h.998l.601 3.182.597-3.182h1.224l.622 3.182.586-3.182h1.013v-.005Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint0_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "matrix(24.4634 0 0 10.6348 21.323 21.375)",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.18, stopColor: "#1657F4" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.57, stopColor: "#0036C4" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint2_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: "matrix(-10.4028 11.2308 26.9553 26.298 19.467 9.93)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.14, stopColor: "#D471FF" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.83, stopColor: "#509DF5", stopOpacity: 0 })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint3_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "matrix(0 9.82726 -52.2747 0 19.118 13.319)",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.28, stopColor: "#4F006F", stopOpacity: 0 }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4F006F" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint5_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: "matrix(-14.7679 3.54088 8.26454 36.3048 20.24 .889)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.06, stopColor: "#E4A7FE" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.54, stopColor: "#E4A7FE", stopOpacity: 0 })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint6_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform: "scale(11.63775 -11.94366) rotate(-45 -.932 -.71)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.08, stopColor: "#367AF2" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.87, stopColor: "#001A8F" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "radialGradient",
        {
          id: "paint7_radial_869_1253",
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "matrix(0 5.91114 -6.56712 0 8.322 16.514)",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: 0.59, stopColor: "#2763E5", stopOpacity: 0 }),
            /* @__PURE__ */ jsx("stop", { offset: 0.97, stopColor: "#58AAFE" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint1_linear_869_1253",
          x1: 5.322,
          y1: 12.528,
          x2: 17.135,
          y2: 12.528,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#66C0FF" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.26, stopColor: "#0094F0" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint4_linear_869_1253",
          x1: 5.322,
          y1: 7.134,
          x2: 20.75,
          y2: 7.384,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#9DEAFF" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.2, stopColor: "#3BD5FF" })
          ]
        }
      )
    ] })
  ] })
);

export { MicrosoftOfficeWordColorIcon };
